// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2YISW","footer":"ModalError_footer__3Ntd4"};